import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templateCompanies = document.createElement('template');

templateCompanies.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class="wrapper">
      <div class="companies-content">
          <div class="companies-grid">
              <gz-grid-view showGlobalActions>
                  <div class="header-buttons" slot="grid-header-actions-slot">

                    <gz-button id='add-company-button' class="mr-2"></gz-button>
                    <gz-button id='delete-company-button' type='outline' color='negative' class="mr-2" disabled></gz-button>

                    <gz-select id="company-actions-split-button" overlayPositionX="left" class="inline-block">
                      <gz-button class="action-split-button" type="quiet" color="secondary">
                        <span id='company-actions-split-button-text' class="company-action-split-button-text"></span>
                        <span class="action-icon ds-icon-dropdown_arrow"></span>
                      </gz-button>
                    </gz-select>

                  </div>

                  <div slot="no-results--additional-data">
                    <gz-text id="companies-empty-state-text" fontSize="14"></gz-text>
                 </div>
              </gz-grid-view>
          </div>
      </div>
  </div>
`;
